import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

/**
 * Shared axios instance for every authenticated backend call.
 *
 * `withCredentials: true` is critical: the backend sets a `session_token`
 * httpOnly cookie with `SameSite=None; Secure`, and the browser will only
 * attach it if the client opts in to credentials.
 *
 * Phase 8: a global 402 interceptor surfaces the `<UpgradeModal>` whenever
 * the backend returns the standard upgrade-required envelope. Components
 * register a single global handler via `setUpgradeHandler()` (called from
 * the BillingProvider on mount). The interceptor then propagates the error
 * to the caller so component-level handlers can still react if they want.
 */
export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
  timeout: 30000,
  headers: { "Content-Type": "application/json" },
});

let _upgradeHandler = null;

/** Registered once by <BillingProvider> on mount. */
export function setUpgradeHandler(fn) {
  _upgradeHandler = typeof fn === "function" ? fn : null;
}

api.interceptors.response.use(
  (res) => res,
  (err) => {
    const status = err?.response?.status;
    const detail = err?.response?.data?.detail;
    if (status === 402 && detail && typeof detail === "object" && _upgradeHandler) {
      try {
        _upgradeHandler(detail);
      } catch (e) {
        console.warn("upgrade handler threw", e);
      }
    }
    return Promise.reject(err);
  },
);
